import { render, staticRenderFns } from "./Storehouse.vue?vue&type=template&id=63325554&scoped=true&"
import script from "./Storehouse.vue?vue&type=script&lang=js&"
export * from "./Storehouse.vue?vue&type=script&lang=js&"
import style0 from "./Storehouse.vue?vue&type=style&index=0&id=63325554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63325554",
  null
  
)

export default component.exports